(function(){
  if(window.__sno3Pdp)return;window.__sno3Pdp=true;
  var root=document.querySelector('.sno3pdp');if(!root)return;
  var variants=[];try{variants=JSON.parse(document.getElementById('sno3pdp-data').textContent);}catch(e){}
  var moneyFmt=function(c){return '£'+(c/100).toFixed(2);};
  var subState={active:false,planId:null,pct:0,plans:[]};
  function subPrice(p){return Math.round(p*(100-subState.pct)/100);}
  var priceEl=document.getElementById('sno3pdp-price');
  var wasEl=document.getElementById('sno3pdp-was');
  var addBtn=document.getElementById('sno3pdp-add');
  var mainImg=document.getElementById('sno3pdp-main');
  var stockEl=document.getElementById('sno3pdp-stock');
  function updateStock(vr){
    if(!stockEl)return;
    var th=parseInt(stockEl.getAttribute('data-threshold'),10)||0;
    if(th>0&&vr&&vr.inventory_management==='shopify'&&typeof vr.inventory_quantity==='number'&&vr.inventory_quantity>0&&vr.inventory_quantity<=th){
      stockEl.textContent='Only '+vr.inventory_quantity+' left in stock';stockEl.hidden=false;
    }else{stockEl.hidden=true;}
  }

  var selected=[];
  root.querySelectorAll('.sno3pdp__optgroup').forEach(function(g){
    var i=parseInt(g.getAttribute('data-option-index'),10);
    var sel=g.querySelector('.sno3pdp__opt.is-sel')||g.querySelector('.sno3pdp__opt');
    selected[i]=sel?sel.getAttribute('data-value'):null;
  });

  function findVariant(){
    if(!selected.length){return variants[0];}
    return variants.find(function(vr){
      return (vr.options||[]).every(function(o,idx){return o===selected[idx];});
    });
  }
  function render(){
    var vr=findVariant();
    if(!vr){addBtn.textContent='Unavailable';addBtn.disabled=true;addBtn.removeAttribute('data-id');return;}
    priceEl.textContent=moneyFmt(subState.active?subPrice(vr.price):vr.price);
    if(wasEl){if(vr.compare_at_price&&vr.compare_at_price>vr.price){wasEl.textContent=moneyFmt(vr.compare_at_price);wasEl.hidden=false;}else{wasEl.hidden=true;}}
    addBtn.setAttribute('data-id',vr.id);
    if(vr.available){addBtn.disabled=false;if(addBtn.textContent==='Sold out'||addBtn.textContent==='Unavailable')addBtn.textContent='Add to basket';}
    else{addBtn.textContent='Sold out';addBtn.disabled=true;}
    if(mainImg&&vr.featured_image&&vr.featured_image.src){mainImg.src=vr.featured_image.src.replace(/(\.[a-z]+)(\?|$)/,'_900x$1$2');}
    updateStock(vr);
    var sp=document.getElementById('sno3pdp-sticky-price');if(sp)sp.textContent=moneyFmt(subState.active?subPrice(vr.price):vr.price);
    var sa=document.getElementById('sno3pdp-sticky-add');if(sa){sa.disabled=addBtn.disabled;sa.textContent=addBtn.disabled?'Sold out':'Add to basket';}
    var oneEl=root.querySelector('[data-po-onetime]');if(oneEl)oneEl.textContent=moneyFmt(vr.price);
    var subEl=root.querySelector('[data-po-sub]');if(subEl)subEl.textContent=moneyFmt(subPrice(vr.price));
  }
  root.querySelectorAll('.sno3pdp__optgroup').forEach(function(g){
    var i=parseInt(g.getAttribute('data-option-index'),10);
    g.querySelectorAll('.sno3pdp__opt').forEach(function(btn){
      btn.addEventListener('click',function(){
        g.querySelectorAll('.sno3pdp__opt').forEach(function(b){b.classList.remove('is-sel');});
        btn.classList.add('is-sel');selected[i]=btn.getAttribute('data-value');render();
      });
    });
  });

  root.querySelectorAll('.sno3pdp__thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.sno3pdp__thumb').forEach(function(x){x.classList.remove('is-sel');});
      t.classList.add('is-sel');if(mainImg)mainImg.src=t.getAttribute('data-full');
    });
  });

  var qtyEl=document.getElementById('sno3pdp-qty');
  root.querySelectorAll('.sno3pdp__qty button').forEach(function(b){
    b.addEventListener('click',function(){
      var q=parseInt(qtyEl.textContent,10)||1;q+=parseInt(b.getAttribute('data-step'),10);if(q<1)q=1;qtyEl.textContent=q;
    });
  });

  function getCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});}
  function updateCount(cart){if(cart&&typeof cart.item_count!=='undefined'){document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count],cart-icon .count').forEach(function(el){el.textContent=cart.item_count;});}}
  function updateShip(cart){
    var el=document.getElementById('sno3pdp-ship');if(!el||!cart)return;
    var th=(parseFloat(el.getAttribute('data-threshold'))||0)*100;if(!th)return;
    var total=cart.total_price||0;var pct=Math.min(100,Math.round(total/th*100));
    var fill=el.querySelector('.sno3pdp__ship-fill');if(fill)fill.style.width=pct+'%';
    var txt=el.querySelector('.sno3pdp__ship-text');
    if(txt){if(total>=th){txt.innerHTML='You’ve unlocked <b>free UK delivery</b>';el.classList.add('is-done');}else{var rem=((th-total)/100).toFixed(2);txt.innerHTML='You’re <b>£'+rem+'</b> away from free UK delivery';el.classList.remove('is-done');}}
  }
  function addToCart(btn){
    var id=addBtn.getAttribute('data-id');if(!id||addBtn.disabled)return;
    var qty=parseInt(qtyEl.textContent,10)||1;var orig=btn.textContent;
    var payload={id:id,quantity:qty};
    if(subState.active&&subState.planId){payload.selling_plan=subState.planId;}
    btn.disabled=true;btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
      .then(function(r){return r.json();})
      .then(function(){btn.textContent='Added ✓';return getCart();})
      .then(function(cart){updateCount(cart);updateShip(cart);setTimeout(function(){btn.textContent=orig;btn.disabled=false;},1600);})
      .catch(function(){btn.textContent=orig;btn.disabled=false;});
  }
  addBtn.addEventListener('click',function(){addToCart(addBtn);});
  var stickyAdd=document.getElementById('sno3pdp-sticky-add');
  if(stickyAdd){stickyAdd.addEventListener('click',function(){addToCart(stickyAdd);});}

  var sticky=document.getElementById('sno3pdp-sticky');
  if(sticky&&'IntersectionObserver'in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(!e.isIntersecting&&e.boundingClientRect.top<0){sticky.classList.add('is-show');}else{sticky.classList.remove('is-show');}});
    },{threshold:0});
    io.observe(addBtn);
  }

  (function(){
    var el=document.getElementById('sno3pdp-deliv');if(!el)return;
    var cutoff=parseInt(el.getAttribute('data-cutoff'),10);if(isNaN(cutoff))cutoff=14;
    var dn=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    function tick(){
      var now=new Date();var d=now.getDay();var h=now.getHours();
      if(d>=1&&d<=5&&h<cutoff){
        var end=new Date(now);end.setHours(cutoff,0,0,0);var ms=end-now;
        var hrs=Math.floor(ms/3600000);var mins=Math.floor((ms%3600000)/60000);
        el.innerHTML='<b>Order within '+hrs+'h '+mins+'m</b> for same-day dispatch';
      }else{
        var nd=new Date(now);do{nd.setDate(nd.getDate()+1);}while(nd.getDay()===0||nd.getDay()===6);
        el.innerHTML='Order now for dispatch on <b>'+dn[nd.getDay()]+'</b>';
      }
    }
    tick();setInterval(tick,30000);
  })();

  // Subscribe & Save: build a one-time / subscription selector from the product's
  // native selling plans (fetched client-side), and pass selling_plan to the cart.
  function buildSub(){
    var cartrow=root.querySelector('.sno3pdp__cartrow');if(!cartrow)return;
    var m=location.pathname.match(/\/products\/([^\/?#]+)/);if(!m)return;
    fetch('/products/'+m[1]+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(p){
        var grp=null,pct=0;
        (p.selling_plan_groups||[]).forEach(function(g){
          (g.selling_plans||[]).forEach(function(pl){
            var a=(pl.price_adjustments||[])[0];
            var v=(a&&a.value_type==='percentage')?a.value:0;
            if(v>pct){pct=v;grp=g;}
          });
        });
        if(!grp||pct<=0)return;
        subState.pct=pct;subState.plans=grp.selling_plans||[];
        subState.planId=subState.plans[0]?subState.plans[0].id:null;
        var opts=subState.plans.map(function(pl){return '<option value="'+pl.id+'">'+pl.name+'</option>';}).join('');
        var wrap=document.createElement('div');wrap.className='sno3pdp__sub';
        wrap.innerHTML=
          '<div class="sno3pdp__po is-sel" data-mode="onetime"><span class="sno3pdp__dot"></span><span class="sno3pdp__pobody"><span class="sno3pdp__poname">One-time purchase</span></span><span class="sno3pdp__poprice" data-po-onetime></span></div>'+
          '<div class="sno3pdp__po" data-mode="sub"><span class="sno3pdp__dot"></span><span class="sno3pdp__pobody"><span class="sno3pdp__poname">Subscribe & Save <span class="sno3pdp__pobadge">-'+pct+'%</span></span><span class="sno3pdp__posub">Deliver <select class="sno3pdp__freq" aria-label="Delivery frequency">'+opts+'</select> &middot; cancel anytime</span></span><span class="sno3pdp__poprice" data-po-sub></span></div>';
        cartrow.parentNode.insertBefore(wrap,cartrow);
        function setMode(mode){
          subState.active=(mode==='sub');
          wrap.querySelectorAll('.sno3pdp__po').forEach(function(l){l.classList.toggle('is-sel',l.getAttribute('data-mode')===mode);});
          render();
        }
        wrap.querySelectorAll('.sno3pdp__po').forEach(function(row){
          row.addEventListener('click',function(){setMode(row.getAttribute('data-mode'));});
        });
        var freq=wrap.querySelector('.sno3pdp__freq');
        if(freq){
          freq.addEventListener('click',function(e){e.stopPropagation();});
          freq.addEventListener('change',function(){subState.planId=freq.value;setMode('sub');});
        }
        render();
      }).catch(function(){});
  }
  buildSub();

  getCart().then(updateShip).catch(function(){});
  render();
})();
